import React, { Fragment } from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import { Button, Col,  Form,  Input,  Row,  Divider } from 'antd';
import EnhancedModal from '../../../../../../components/enhanced-modal';
import { MODAL_WIDTH_LG, SPAN_FULL, GUTTER_MD, MARGIN_SM, MODAL_WIDTH_MD, SPAN_ONE_THIRD, SPAN_TWO_THIRDS, SPAN_ONE_QUARTER, SPAN_THREE_QUARTERS, SPAN_HALF, GUTTER_XS, MARGIN_XS, MARGIN_MD} from '../../../../../../styles/constants';
import functionsData from '../../../../../../config/functions.json';
import { hideFileMappingWizardAddFieldFunctionWizard,
        showFileMappingWizardAddFieldFunctionSubstrFormChange,
        onSubmitFunction } from '../actions';
import FileMappingWizardSubstrWizard from './substr-wizard';
import FileMappingWizardReplaceWizard from './replace-wizard';
import FileMappingWizardTrimWizard from './trim-wizard';
import FileMappingWizardPadWizard from './pad-wizard';
import FileMappingWizardConcatWizard from './concat-wizard';
import FileMappingWizardIIFWizard from './if-wizard/IffComponent';
import FileMappingWizardCaseWizard from './case-wizard/CaseComponent';
import _ from "lodash";

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  addFieldFunctionWizardVisible: state.scenes.dataManager.fileMapping.components.wizard.components.addField.addFieldFunctionWizardVisible,
  functionType: state.scenes.dataManager.fileMapping.components.wizard.components.addField.functionType,
  submitable: state.scenes.dataManager.fileMapping.components.wizard.components.addField.submitable,
});

const mapDispatchToProps = dispatch => ({
  onAddFieldFunctionWizardHide: () => dispatch(hideFileMappingWizardAddFieldFunctionWizard()),
  onChange: fields => dispatch(showFileMappingWizardAddFieldFunctionSubstrFormChange(fields)),
  onFunctionSubmit: (functionTypeName, functionTypeBase) => dispatch(onSubmitFunction(functionTypeName, functionTypeBase))
});

const FileMappingWizardAddFieldFunctionWizard = ({
                                                t,
                                                addFieldFunctionWizardVisible,
                                                onAddFieldFunctionWizardHide,
                                                functionType,
                                                appLanguage,
                                                submitable,
                                                onFunctionSubmit,
                                              }) => {
  return (
    
    <Fragment>
      <EnhancedModal
        visible={addFieldFunctionWizardVisible}
        width={functionType !== null && (functionType.Name === 'Case' || functionType.Name === 'IIF' ) ? MODAL_WIDTH_LG : MODAL_WIDTH_MD}
        title={(functionType !== null ) && functionsData.Functions.find(f => f.Name === functionType.Name).Name}
        onCancel={onAddFieldFunctionWizardHide}
        footer={
          <div>
            <Button 
              onClick={onAddFieldFunctionWizardHide}
              style={{marginRight: MARGIN_SM}}
            >
              {t('commons.buttons.close.title')}
            </Button>
            <Button
              onClick={() => onFunctionSubmit(functionType !== null ? functionType.Name : '', functionType !== null ? functionType.Function : '',)}
              type="primary"
              disabled={!submitable}
            >
              {t('commons.buttons.confirm.title')}
            </Button>
          </div>
        }
      >
        <Row type="flex" justify="center">
          <Col style={{width: functionType !== null && (functionType.Name === 'Case' || functionType.Name === 'IIF') ? MODAL_WIDTH_LG : MODAL_WIDTH_MD}}>
              <Row type='flex' style={{marginBottom:MARGIN_XS}}>
                <Col span={4} style={{textAlign:'right', paddingRight:MARGIN_SM }} >
                  <span>
                    {t('data.fileMapping.addField.functionWizard.description.label')}</span>
                </Col>
                <Col span={20}>
                  <Input.TextArea 
                    readOnly={true}
                    value={(functionType !== null ) && ((appLanguage === 'en') && functionsData.Functions.find(f => f.Name === functionType.Name).Description.en || functionsData.Functions.find(f => f.Name === functionType.Name).Description.it)}
                    style={{
                      overflow: 'auto',
                      resize: 'none',
                      height: 50
                    }}
                  />
                </Col>      
              </Row>
              <Row type='flex' style={{marginBottom:MARGIN_XS}}> 
                  <Col span={4} style={{textAlign:'right', paddingRight:MARGIN_SM }} >
                  <span>
                    {t('data.fileMapping.addField.functionWizard.example.label')}</span>
                  </Col>
                  <Col span={20}>  
                    <Input.TextArea 
                      readOnly={true}
                      value={(functionType !== null ) && functionsData.Functions.find(f => f.Name === functionType.Name).Example}
                      style={{
                        overflow: 'auto',
                        resize: 'none',
                        height: 50
                      }}
                    />
                  </Col>   
              </Row>
            <Divider/>

            <Form className="advanced-form">
              <Row type='flex' justify='center' gutter={GUTTER_MD}>
                {(functionType !== null && functionType.Name === 'Concat') && (
                  <FileMappingWizardConcatWizard />
                )}
                {(functionType !== null && functionType.Name === 'Replace') && (
                  <FileMappingWizardReplaceWizard/>
                )}
                {(functionType !== null && functionType.Name === 'Substr') && (
                  <FileMappingWizardSubstrWizard/>
                )}
                {(functionType !== null && (functionType.Name === 'Trim' || functionType.Name === 'LTrim' || functionType.Name === 'RTrim' ) ) && (
                  <FileMappingWizardTrimWizard />
                )}
                {(functionType !== null && (functionType.Name === 'LPad' || functionType.Name === 'RPad')) && (
                  <FileMappingWizardPadWizard/>
                )}
                {(functionType !== null && functionType.Name === 'IIF' ) && (
                  <FileMappingWizardIIFWizard />
                )}
                {(functionType !== null && functionType.Name === 'Case' ) && (
                  <FileMappingWizardCaseWizard />
                )}
              </Row>
            </Form>
          </Col>
        </Row>

      </EnhancedModal>
    </Fragment>

);
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
  )(FileMappingWizardAddFieldFunctionWizard);